export const scrollPositionConstants = {
    POSITION_Y: 'position_y',
    TABLE_BEFORE_CONTENT_VISIBLE: 'table_before_content_visible'
}

export const scrollPositionInitialState = {
    type: '',
    positionY: 0,
    tableBeforeContentVisible: true
}

interface ScrollPositionReducerStateInterface {
    type: string;
    positionY: number;
    tableBeforeContentVisible: boolean;
}

interface ScrollPositionReducerActionInterface {
    type: string,
    positionY: number,
    tableBeforeContentVisible: boolean,
}

export const scrollPositionReducer = (state: ScrollPositionReducerStateInterface = scrollPositionInitialState, action: ScrollPositionReducerActionInterface): ScrollPositionReducerStateInterface => {
    switch (action.type) {
        case scrollPositionConstants.POSITION_Y:
            return {
                type: action.type,
                positionY: action.positionY,
                tableBeforeContentVisible: state.tableBeforeContentVisible,
            }
        case scrollPositionConstants.TABLE_BEFORE_CONTENT_VISIBLE:
            return {
                type: action.type,
                positionY: state.positionY,
                tableBeforeContentVisible: action.tableBeforeContentVisible,
            }
        default:
            return {
                type: '',
                positionY: state.positionY,
                tableBeforeContentVisible: state.tableBeforeContentVisible
            }
    }
}